import { render } from "./ToggleButton.vue?vue&type=template&id=18e420e4&scoped=true"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=18e420e4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/dindin.mombaby.kroutony.me/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e420e4"]])

export default __exports__